import cms, { namespace as cmsNamespace } from './modules/cms-store';
import user, { namespace as userNamespace } from './modules/user-store';
import appState, { namespace as appStateNamespace } from './modules/app-store';
import userAuth, { namespace as userAuthNamespace } from './modules/auth-store';

export default {
	[appStateNamespace]: appState(),
	[userNamespace]: user(),
	[userAuthNamespace]: userAuth(),
	[cmsNamespace]: cms(),
};
